module.exports = __webpack_public_path__ + "img/fukuoka.65620a39.png";